import { WEB_VERSION } from './version';

window._ = require('lodash');
window.Popper = require('popper.js').default;

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
  window.$ = window.jQuery = require('jquery');

  require('bootstrap');
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

// Call the API same-origin (relative) so the session cookie is sent and there is no CORS.
// window.VITE_API_URL overrides this only when explicitly set (e.g. the Prism mock server).
window.axios.defaults.baseURL = window.VITE_API_URL || '';

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// Web クライアントの版数を BE のリクエストログに残す（client=Web と一緒に appVersion として記録される）。
// X-APP は送らないので BE のネイティブ判定はされない。版数は src/version.js で一元管理。
window.axios.defaults.headers.common['X-APP-VERSION'] = WEB_VERSION;

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
  window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
  console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

let commin_guest = document.head.querySelector('meta[name="commin-guest"]');
let commin_lang = document.head.querySelector('meta[name="commin-lang"]');
if (commin_guest && commin_lang) {
  window.$G = Number(commin_guest.content);
  window.$L = commin_lang.content;
  window.axios.defaults.headers.common['X-GUEST'] = window.$G;
  window.axios.defaults.headers.common['X-LANG'] = window.$L;
}

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo'

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     encrypted: true
// });
